import { use } from 'react';
import { CancelFlowContext, type CancelFlowContextType } from './CancelFlowContext';

export const useCancelFlow = (): CancelFlowContextType => {
  const context = use(CancelFlowContext);
  if (context === undefined) {
    throw new Error('useCancelFlow must be used within a CancelFlowProvider');
  }
  return context;
};
